import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import WebsiteLoader from "../../Components/WebsiteLoader";
import { defaultJobsPerPage } from "../../utils/Constants";
import { post } from "../../utils/jobsAxiosInstance";
import FilterJobs from "./FilterJobs";
import Jobs from "./Jobs";
import { convertToGoogleJobsJSON } from "../../utils/helper";
import cloneDeep from 'lodash/cloneDeep'

export const useCommonJobStyles = makeStyles((theme) => ({
    root: {
        '& section': {
            [theme.breakpoints.down("sm")]: {
                padding: '4rem 2rem 1rem 2rem',
            },
            padding: '2rem 6rem',
        },
        '& section:nth-child(odd)': {
            backgroundColor: '#F3F6FC',
        },
        '& h1': {
            marginTop: 0,
            fontSize: '2.5rem',
        },
        '& h2': {
            margin: 0,
            fontSize: '2rem',
        },
        '& h3': {
            margin: 0,
            fontSize: '1.5rem',
        },
        '& h4': {
            margin: 0,
            fontSize: '1rem',
        },
        '& span': {
            fontSize: '1rem',
        },
        '& p': {
            fontSize: '1rem',
        }
    },
    textCenter: {
        textAlign: 'center',
    },
    customScroll: {
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            height: '5px',
            width: '5px',
        },
        '&:hover::-webkit-scrollbar-thumb': {
            borderRadius: '5px',
            background: '#707070',
        },
        '&:hover::-webkit-scrollbar-track': {
            borderRadius: '5px',
            boxShadow: 'inset 0 0 3px grey',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#8b8b8b',
        },
    }
}))

const JobsPage = (props) => {
    const classes = useCommonJobStyles();

    const [visibleFooterSize, setVisibleFooterSize] = useState(0);
    const [jobs, setJobs] = useState(null);
    const [currPage, setCurrPage] = useState(0);
    const [userFilters, setUserFilters] = useState({});
    const [searchFilters, setSearchFilters] = useState({});
    const [loading, setLoading] = useState(false);
    const [rawFilters, setRawFilters] = useState();

    useEffect(() => {
        const handleScroll = () => {
            const element = document.getElementById('website-footer');
            if (element) {
                const rect = element.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const visibleHeight = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
                setVisibleFooterSize(visibleHeight);
            }
        };

        handleScroll();
        getJobs();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [userFilters]);

    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.innerHTML = JSON.stringify(convertToGoogleJobsJSON(jobs?.elasticJobs));

        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, [jobs])

    const formatRequestFilterData = () => {
        const filter = cloneDeep(userFilters);
        if (filter['locations']) {
            const countriesMap = {};
            for (const location of filter['locations']) {
                const containsAllStates = location.child.toLowerCase().includes("all ");
                let states = countriesMap[location['groupKey']];
                if (containsAllStates) {
                    states = rawFilters['locations']?.[location.groupKey]
                    countriesMap[location['groupKey']] = [...states];
                } else {
                    countriesMap[location['groupKey']] = states?.length > 0 ? [...states, location.child] : [location.child];
                }
            }
            filter['locations'] = countriesMap;
        }
        return filter;
    }

    const getJobs = (page) => {
        setLoading(true);
        post('/search', {
            ...formatRequestFilterData(),
            ...searchFilters,
            "pageNumber": (page !== null || page !== undefined) ? page : currPage,
            "pageSize": defaultJobsPerPage
        })
            .then((res) => {
                if (res?.data?.elasticJobs?.length !== 0) {
                    setJobs(res?.data);
                } else {
                    setJobs(null);
                    setCurrPage(0);
                }
            })
            .catch(() => {
                setJobs(null);
                setCurrPage(0);
            })
            .finally(() => setLoading(false))
    }

    return (
        <section className={classes.root}>
            <WebsiteLoader loading={loading} />
            <FilterJobs
                getJobs={getJobs}
                userFilters={userFilters}
                setUserFilters={setUserFilters}
                searchFilters={searchFilters}
                setSearchFilters={setSearchFilters}
                setRawFilters={setRawFilters}
            />
            <Jobs
                visibleFooterSize={visibleFooterSize}
                currPage={currPage}
                setCurrPage={setCurrPage}
                jobs={jobs}
                getJobs={getJobs}
                loading={loading}
            />
        </section>
    )
}

export default JobsPage;